import { Router, ActivatedRoute, Params } from '@angular/router';
import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  NgZone,
} from '@angular/core';
import { ISearchSupplier } from '../../interfaces/search-supplier';
import { IVehicleAddress } from '../../interfaces/task-info';
import { InboxJobsService } from '../../services/inbox-jobs.service';
import { JobsService } from '../../services/job.service';
import { MapService } from '../../services/map.service';
import { BBWTMessageService } from '../../services/message.service';
import { FormControl, UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { SearchCriteriaService } from '../../services/search-criteria.service';
import { TaskService } from '../../services/task.service';

@Component({
  selector: 'search-supplier',
  templateUrl: './search-supplier.component.html',
  encapsulation: ViewEncapsulation.None, // todo: check why
})
export class SearchSupplierComponent implements OnInit {
  public isBusy: boolean = false;
  public id: number;
  public searchSupplierForm: UntypedFormGroup;
  public searchSupplierForms: any;
  public searchCriteria: ISearchSupplier = <ISearchSupplier>{};
  public items: any[] = [];
  public selectedJob: any;

  @ViewChild('pickupLocationRef')
  public pickupLocationRef: ElementRef;
  @ViewChild('dropoffLocationRef')
  public dropoffLocationRef: ElementRef;

  @Output() pickupLocationChange: EventEmitter<IVehicleAddress>;
  public _pickupLocation: IVehicleAddress;
  @Input('pickupLocation')
  public set pickupLocation(value: IVehicleAddress) {
    if (this.objectComparer(value, this._pickupLocation)) {
      return;
    }

    this._pickupLocation = value;
    this.pickupLocationChange.emit(value);

    this.searchCriteria.pickupLocation = value;

    if (
      this._pickupLocation &&
      (this._pickupLocation.primaryAddress == null || this._pickupLocation.primaryAddress == '')
    ) {
      var than = this;

      this.LoadAddress(
        null,
        null,
        null,
        null,
        this._pickupLocation.latitude,
        this._pickupLocation.longitude,
      )
        .then((result) => {
          if (result != null) {
            if (result.formatted_address) {
              var line1 = result.formatted_address + '';
              line1 = line1.trim();
              if (line1.endsWith(', UK')) {
                line1 = line1.substring(0, line1.length - 4);
              }
            } else if (result.street_number) var line1 = result.street_number + ' ' + result.route;
            else var line1 = result.route + ' ';

            than.pickupLocation = {
              id: 0,
              primaryAddress: line1,
              secondary: '',
              postcode: result.postal_code,
              city: result.postal_town,
              country: result.country,
              latitude: result.lat,
              longitude: result.lng,
              route: result.route,
              postal_town: result.postal_town,
              addressLine1: result.street_number
                ? result.street_number + ' ' + result.route
                : result.route,
              addressLine2: result.locality,
              addressLine3: result.postal_code,
            };
          } else {
            than.pickupLocation = null;
          }
        })
        .catch((err) => {
          than.pickupLocation = null;
          //than.isSearchPickup = false;
        });
    } else if (
      this._pickupLocation &&
      (this._pickupLocation.latitude == null || this._pickupLocation.longitude == null)
    ) {
      var than = this;
      //than.isSearchPickup = true;

      this.LoadAddress(
        this._pickupLocation.primaryAddress,
        this._pickupLocation.city,
        this._pickupLocation.postcode,
        this._pickupLocation.country,
        null,
        null,
      )
        .then((result) => {
          if (result != null) {
            if (result.formatted_address) {
              var line1 = result.formatted_address + '';
              line1 = line1.trim();
              if (line1.endsWith(', UK')) {
                line1 = line1.substring(0, line1.length - 4);
              }
            } else if (result.street_number) var line1 = result.street_number + ' ' + result.route;
            else var line1 = result.route + ' ';

            than.pickupLocation = {
              id: 0,
              primaryAddress: line1,
              secondary: '',
              postcode: result.postal_code,
              city: result.postal_town,
              country: result.country,
              latitude: result.lat,
              longitude: result.lng,
              route: result.route,
              postal_town: result.postal_town,
              addressLine1: result.street_number
                ? result.street_number + ' ' + result.route
                : result.route,
              addressLine2: result.locality,
              addressLine3: result.postal_code,
            };
          } else {
            than.pickupLocation = null;
          }

          //than.isSearchPickup = false;
        })
        .catch((err) => {
          than.pickupLocation = null;
          //than.isSearchPickup = false;
        });
    }
  }
  public get pickupLocation(): IVehicleAddress {
    return this._pickupLocation;
  }

  @Output() dropoffLocationChange: EventEmitter<IVehicleAddress>;
  public _dropoffLocation: IVehicleAddress;
  @Input('dropoffLocation')
  public set dropoffLocation(value: IVehicleAddress) {
    if (this.objectComparer(value, this._dropoffLocation)) {
      return;
    }

    this._dropoffLocation = value;
    //this.task.dropoffLocation = value;
    this.dropoffLocationChange.emit(value);

    //var routeTimePromise = this.CalculateRouteTime();

    if (
      this._dropoffLocation &&
      (this._dropoffLocation.primaryAddress == null || this._dropoffLocation.primaryAddress == '')
    ) {
      var than = this;
      //than.isSearchDropoff = true;
      this.LoadAddress(
        null,
        null,
        null,
        null,
        this._dropoffLocation.latitude,
        this._dropoffLocation.longitude,
      )
        .then((result) => {
          if (result != null) {
            if (result.formatted_address) {
              var line1 = result.formatted_address + '';
              line1 = line1.trim();
              if (line1.endsWith(', UK')) {
                line1 = line1.substring(0, line1.length - 4);
              }
            } else if (result.street_number) var line1 = result.street_number + ' ' + result.route;
            else var line1 = result.route + ' ';

            than.dropoffLocation = {
              id: 0,
              primaryAddress: line1,
              secondary: '',
              postcode: result.postal_code,
              country: result.country,
              city: result.postal_town,
              latitude: result.lat,
              longitude: result.lng,
              route: result.route,
              postal_town: result.postal_town,
              addressLine1: result.street_number
                ? result.street_number + ' ' + result.route
                : result.route,
              addressLine2: result.locality,
              addressLine3: result.postal_code,
            };
          } else {
            than.dropoffLocation = null;
          }

          //routeTimePromise ? routeTimePromise.then(() => than.isSearchDropoff = false) : than.isSearchDropoff = false;
        })
        .catch((err) => {
          than.dropoffLocation = null;
          //than.isSearchDropoff = false;
        });
    } else if (
      this._dropoffLocation &&
      (this._dropoffLocation.latitude == null || this._dropoffLocation.longitude == null)
    ) {
      var than = this;
      //than.isSearchDropoff = true;

      this.LoadAddress(
        this._dropoffLocation.primaryAddress,
        this._dropoffLocation.city,
        this._dropoffLocation.postcode,
        this._dropoffLocation.country,
        null,
        null,
      )
        .then((result) => {
          if (result != null) {
            if (result.formatted_address) {
              var line1 = result.formatted_address + '';
              line1 = line1.trim();
              if (line1.endsWith(', UK')) {
                line1 = line1.substring(0, line1.length - 4);
              }
            } else if (result.street_number) var line1 = result.street_number + ' ' + result.route;
            else var line1 = result.route + ' ';

            than.dropoffLocation = {
              id: 0,
              primaryAddress: line1,
              secondary: '',
              postcode: result.postal_code,
              city: result.postal_town,
              country: result.country,
              latitude: result.lat,
              longitude: result.lng,
              route: result.route,
              postal_town: result.postal_town,
              addressLine1: result.street_number
                ? result.street_number + ' ' + result.route
                : result.route,
              addressLine2: result.locality,
              addressLine3: result.postal_code,
            };
          } else {
            than.dropoffLocation = null;
          }

          //than.isSearchDropoff = false;
        })
        .catch((err) => {
          than.dropoffLocation = null;
          //than.isSearchDropoff = false;
        });
    }
  }
  public get dropoffLocation(): IVehicleAddress {
    return this._dropoffLocation;
  }

  public _pickupDistance: number;
  @Output() pickupDistanceChange: EventEmitter<number>;
  @Input('pickupDistance')
  public set pickupDistance(value: number) {
    this._pickupDistance = value;
    this.searchCriteria.fromRadius = value;
    this.UpdateMapPoint();
    this.pickupDistanceChange.emit(value);
  }
  public get pickupDistance(): number {
    return this._pickupDistance;
  }

  public locationPoins: Array<any> = [];

  constructor(
    private searchCriteriaService: SearchCriteriaService,
    private route: ActivatedRoute,
    private router: Router,
    public messageService: BBWTMessageService,
    private formBuilder: UntypedFormBuilder,
    private mapService: MapService,
    private taskService: TaskService,
    private mapsAPILoader: MapsAPILoader,
    private inboxjobsService: InboxJobsService,
    private ngZone: NgZone,
    private jobService: JobsService,
  ) {
    this.pickupLocationChange = new EventEmitter<IVehicleAddress>();
    this.dropoffLocationChange = new EventEmitter<IVehicleAddress>();
    this.pickupDistanceChange = new EventEmitter<number>();
  }

  ngOnInit() {
    this.id = this.route.snapshot.params['id'];
    this.taskService.GetTask(this.id.toString()).then((x) => {
      this.pickupLocation = x.pickupLocation;
      this.dropoffLocation = x.dropoffLocation;
      this.UpdateMapPoint();
    });

    this.searchCriteria.taskId = this.id;
  }

  GetNormalAddress(address) {
    while (address.length > 35) {
      var index = address.lastIndexOf(',');
      address = address.slice(0, index);
    }

    return address;
  }

  tasksCountPostfix(item, value) {
    if (value == null || value == '' || item.tasksCount < 2) return value;
    return value + ' (+' + (item.tasksCount - 1) + ')';
  }

  UpdateMapPoint() {
    this.locationPoins = [];
    if (this.pickupLocation != null && this.pickupDistance != null && this.pickupDistance > 0) {
      this.locationPoins.push({
        longitude: this.pickupLocation.longitude,
        latitude: this.pickupLocation.latitude,
        label: 'From',
        radius: this.pickupDistance * 1000,
        color: 'red',
      });
    }

    if (this.dropoffLocation != null) {
      this.locationPoins.push({
        longitude: this.dropoffLocation.longitude,
        latitude: this.dropoffLocation.latitude,
        label: 'To',
        color: 'green',
      });
    }
    this.isBusy = false;
  }

  LoadAddress(
    primary: string,
    city: string,
    postalcode: string,
    country: string,
    lat: number,
    lng: number,
  ): Promise<any> {
    var address = [];
    if (primary) {
      address.push(primary);
    }

    if (city) {
      address.push(city);
    }

    if (postalcode) {
      address.push(postalcode);
    }

    if (country) {
      address.push(country);
    }

    if (lat && lng) {
      address.push(lat, lng);
    }
    return this.mapService.GetAddress(address.join());
  }

  search() {
    //this.searchCriteria.pickupLocation = this.pickupLocation;

    this.jobService.searchSuppliers(this.searchCriteria).then((res) => {
      this.items = res;
    });
  }

  close() {
    window.history.back();
  }

  objectComparer(x, y) {
    if (x === y) return true;
    // if both x and y are null or undefined and exactly the same

    if (!(x instanceof Object) || !(y instanceof Object)) return false;
    // if they are not strictly equal, they both need to be Objects

    if (x.constructor !== y.constructor) return false;
    // they must have the exact same prototype chain, the closest we can do is
    // test there constructor.

    for (var p in x) {
      if (!x.hasOwnProperty(p)) continue;
      // other properties were tested using x.constructor === y.constructor

      if (!y.hasOwnProperty(p)) return false;
      // allows to compare x[ p ] and y[ p ] when set to undefined

      if (x[p] === y[p]) continue;
      // if they have the same strict value or identity then they are equal

      if (typeof x[p] !== 'object') return false;
      // Numbers, Strings, Functions, Booleans must be strictly equal

      if (!this.objectComparer(x[p], y[p])) return false;
      // Objects and Arrays must be tested recursively
    }

    for (p in y) {
      if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
      // allows x[ p ] to be set to undefined
    }
    return true;
  }

  public addressStr(addr: any) {
    var addrStr = new Array();
    if (addr == null) return '';
    if (addr.addressLine1) {
      addrStr.push(addr.addressLine1);
    }

    if (addr.addressLine2) {
      addrStr.push(addr.addressLine2);
    }

    if (addr.addressLine3) {
      addrStr.push(addr.addressLine3);
    }

    if (addr.town) {
      addrStr.push(addr.town);
    }

    if (addr.postcode) {
      addrStr.push(addr.postcode);
    }
    return addrStr.join(', ');
  }

  public contactStr(addr: any) {
    var addrStr = new Array();
    if (addr == null) return '';

    if (addr.emailAddress) {
      addrStr.push('Email: ' + addr.emailAddress);
    }

    if (addr.phoneNumber) {
      addrStr.push('Phone: ' + addr.phoneNumber);
    }
    return addrStr.join('; ');
  }
}
